import React from 'react';
import Hero from './components/IQAC/Committee-letter/Hero';
import Main from './components/IQAC/Committee-letter/Main';

const IqacCommitteeLetter = () => {
    return (
        <div>
            <Hero />
            <Main />
        </div>
    )
}

export default IqacCommitteeLetter;